/* ==========================================================================
   Image registry.

   IMAGERY POLICY

   The site uses two photographs — bethel-hero.jpg and bethel-hero-2.jpg —
   both abstract architectural shots that read as institutional and hold up
   full-bleed. Plus the logo artwork and three client marks.

   The rest of the originally supplied library has been removed from the repo
   (about 11 MB). It was never imported, so it never shipped, but it was
   inflating every clone and deploy. Nothing is lost: the files remain in git
   history and can be recovered with
   `git show <commit>:src/assets/img/<file>`.

   Why those files were not used, for the record:
     • cyber-hero.jpg, ci.jpg, enterprise-servicesHero.jpg, solutions.jpg —
       generic "glowing tech overlay" stock. The visual cliché that makes a
       contractor site read as dated. One had the word HACKED across it in
       neon, on a cybersecurity firm's own page.
     • about-bg.png — an AI-generated stock group photo, recognisably so.
     • bethel-story.png, bethel-wwd.png, bethel-why.png, philo.png,
       cim-hero.png, bethel-services.png — flat clipart on white; cheap at
       section width.
     • home-about.png, profile-example.png — cartoon illustrations. The
       previous site captioned one of these as the founder's photograph.
     • clients.png, clients.jpeg, enterprise.jfif, *.svg duplicates,
       bethel-logo.jpg — superseded or duplicated by the files kept above.

   See README for the photography brief.
   ========================================================================== */

import heroExterior from '../assets/img/bethel-hero.jpg';
import heroInterior from '../assets/img/bethel-hero-2.jpg';

export const images = {
  heroExterior,
  heroInterior,
};
